import { render, staticRenderFns } from "./detailsProduct.vue?vue&type=template&id=5e38f55e&scoped=true&"
import script from "./detailsProduct.vue?vue&type=script&lang=js&"
export * from "./detailsProduct.vue?vue&type=script&lang=js&"
import style0 from "./detailsProduct.vue?vue&type=style&index=0&id=5e38f55e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e38f55e",
  null
  
)

export default component.exports